"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ILUUnitDto {
}
exports.ILUUnitDto = ILUUnitDto;
var IluStatus;
(function (IluStatus) {
    IluStatus[IluStatus["Available"] = 0] = "Available";
    IluStatus[IluStatus["Occupied"] = 1] = "Occupied";
    IluStatus[IluStatus["OutOfService"] = 2] = "OutOfService";
    IluStatus[IluStatus["Sold"] = 3] = "Sold";
})(IluStatus = exports.IluStatus || (exports.IluStatus = {}));
